import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const Crown = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        fill='none'
        height='15'
        viewBox='0 0 15 15'
        width='15'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='material-symbols:crown-outline'>
          <path
            d='M3.41699 12.1667V11.0001H11.5837V12.1667H3.41699ZM3.41699 10.1251L2.67324 5.44383C2.6538 5.44383 2.63183 5.44636 2.60733 5.45142C2.58283 5.45647 2.56105 5.4588 2.54199 5.45842C2.29894 5.45842 2.09244 5.37325 1.92249 5.20292C1.75255 5.03258 1.66738 4.82608 1.66699 4.58342C1.6666 4.34075 1.75177 4.13425 1.92249 3.96392C2.09322 3.79358 2.29972 3.70842 2.54199 3.70842C2.78427 3.70842 2.99097 3.79358 3.16208 3.96392C3.33319 4.13425 3.41816 4.34075 3.41699 4.58342C3.41699 4.65147 3.4096 4.71467 3.39483 4.773C3.38005 4.83133 3.36313 4.8848 3.34408 4.93342L5.16699 5.75008L6.98991 3.25633C6.88297 3.17855 6.79547 3.07647 6.72741 2.95008C6.65935 2.82369 6.62533 2.68758 6.62533 2.54175C6.62533 2.29869 6.71049 2.092 6.88083 1.92167C7.05116 1.75133 7.25766 1.66636 7.50033 1.66675C7.74299 1.66714 7.94969 1.7523 8.12041 1.92225C8.29113 2.09219 8.3761 2.29869 8.37533 2.54175C8.37533 2.68758 8.3413 2.82369 8.27324 2.95008C8.20519 3.07647 8.11769 3.17855 8.01074 3.25633L9.83366 5.75008L11.6566 4.93342C11.6371 4.8848 11.62 4.83133 11.6052 4.773C11.5905 4.71467 11.5833 4.65147 11.5837 4.58342C11.5837 4.34036 11.6688 4.13367 11.8392 3.96333C12.0095 3.793 12.216 3.70803 12.4587 3.70842C12.7013 3.7088 12.908 3.79397 13.0787 3.96392C13.2495 4.13386 13.3344 4.34036 13.3337 4.58342C13.3329 4.82647 13.2479 5.03317 13.0787 5.2035C12.9096 5.37383 12.7029 5.4588 12.4587 5.45842C12.4392 5.45842 12.4174 5.45608 12.3933 5.45142C12.3692 5.44675 12.3472 5.44422 12.3274 5.44383L11.5837 10.1251H3.41699ZM4.40866 8.95842H10.592L10.9712 6.523L9.43991 7.19383L7.50033 4.52508L5.56074 7.19383L4.02949 6.523L4.40866 8.95842Z'
            fill='#F8F8F8'
            id='Vector'
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
export default Crown;
